import {
  Component,
  HostListener,
  Inject,
  Injector,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { CR, jkAlert, jkLib, jkRestReturn } from 'jk-service';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogModule,
  MatDialogContent,
} from '@angular/material/dialog';
import { JkBaseComponent } from 'jk-service';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FullCalendarComponent } from '@fullcalendar/angular';

export function dateFormat(dt: any) {
  dt = new Date(dt);
  const month =
    dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1;
  const date = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate();
  const hours = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours();
  const mins = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes();
  dt = dt.getFullYear() + '-' + month + '-' + date + 'T' + hours + ':' + mins;
  return dt;
}

@Component({
  selector: 'app-jkabout',
  templateUrl: './jk-calendar-edit.component.html',
  styleUrls: [],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButtonModule, MatDialogModule, CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
})
export class JkCalendarEditComponent extends JkBaseComponent implements OnInit {
  @Input() value: string = '';
  @Input() isModal: boolean = false;
  @Input() params!: FormGroup;
  @Input() events: any[] = [];
  @Input() calendar!: FullCalendarComponent;
  minStartDate: any = '';
  minEndDate: any = '';

  constructor(injector: Injector,
    public dialogRef: MatDialogRef<JkCalendarEditComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) {
    super();
    if (this.data) {
      let param = this.data.obj;
      this.params = param.params
      this.events = param.events;
      this.calendar = param.calendar;
      this.minStartDate = param.minStartDate;
      this.minEndDate = param.minEndDate;
      //this.title = data.title;
    }
  }
  override ngOnInit(): void {
    super.ngOnInit();
  }

  @HostListener('window:popstate')
  onPopState() {
  }

  onNoClick(result: boolean): void {
    this.data.result = result;
    this.dialogRef.close(this.data);
  }
  saveEvent() {
    if (!this.params.value.title) {
      return;
    }
    if (!this.params.value.start) {
      return;
    }
    if (!this.params.value.end) {
      return;
    }

    if (this.params.value.id) {
      //update event
      let event = this.events.find((d: any) => d.id == this.params.value.id);
      event.title = this.params.value.title;
      event.start = this.params.value.start;
      event.end = this.params.value.end;
      event.description = this.params.value.description;
      event.className = this.params.value.type;
    } else {
      //add event
      let maxEventId = 0;
      if (this.events) {
        maxEventId = this.events.reduce(
          (max: number, character: any) =>
            character.id > max ? character.id : max,
          this.events[0].id
        );
      }

      let event = {
        id: maxEventId + 1,
        title: this.params.value.title,
        start: this.params.value.start,
        end: this.params.value.end,
        description: this.params.value.description,
        className: this.params.value.type,
      };
      this.events.push(event);
    }
    this.calendar.getApi(); //refresh Calendar
    //this.showMessage('Event has been saved successfully.');
    jkAlert('Event has been saved successfully.');
    //this.isAddEventModal.close();
  }
  startDateChange(event: any) {
    const dateStr = event.target;
    if (dateStr) {
      this.minEndDate = dateFormat(dateStr);
      this.params.patchValue({ end: '' });
    }
  }

}
